import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Tooltip } from '@ontruck/orc';

const StyledTooltipClassNameReplacer = ({ className, ...rest }) => (
  <Tooltip tooltipClassName={className} {...rest} />
);

StyledTooltipClassNameReplacer.propTypes = {
  className: PropTypes.string,
};

export default styled(StyledTooltipClassNameReplacer)`
  padding: ${(props) => props.theme.base.gridSizes.XXS} ${(props) => props.theme.base.gridSizes.XS};
`;
